/**
 * PXP Experimentation helper
 * @flow
 */

let treatments = {}

/**
 * Return a simple API that lets us determine if features are available
 * @example - if(isTreatment("your-feature")) doStuff()
 * @param {string} treatment - treatment name
 * @return {boolean} if the treatment is available
 */
export function isTreatment(treatment: string): boolean {
  return Boolean(treatments[treatment])
}

export function allTreatments(...treatmentNames: string[]): boolean {
  return treatmentNames.every(name => isTreatment(name))
}

export function anyTreatment(...treatmentNames: string[]): boolean {
  return treatmentNames.some(name => isTreatment(name))
}

export function addTreatments(treatmentKV: { [key: string]: boolean }) {
  for (const treatment in treatmentKV) {
    treatments[treatment] = Boolean(treatmentKV[treatment])
  }
}

export function clearTreatments(): void {
  treatments = {}
}
